const LEASE_END_ACTIONS = {
  CONTINUE_MONTHLY: 'CONTINUE_MONTHLY',
  TERMINATE: 'TERMINATE',
};

module.exports = LEASE_END_ACTIONS;
